// Librairies
import { Type } from '@angular/core';

// Classes
import { WidgetDirective } from './widget.directive';

// Components
import { ChartComponent } from './chart/chart.component';
import { ForgeComponent } from './forge/forge.component';
import { HeatmapComponent } from './heatmap/heatmap.component';
import { ImageComponent } from './image/image.component';
import { InsightComponent } from './insight/insight.component';
import { MapsComponent } from './maps/maps.component';
import { PlanningWidget } from './planning/planning.widget';
import { ProjectMapComponent } from './project-map/project-map.component';
import { TableComponent } from './table/table.component';
import { TextComponent } from './text/text.component';
import { VideoComponent } from './video/video.component';
import { WeatherComponent } from './weather/weather.component';

// What a dashboard, the editor or the fullscreen view can hand to a widget, on top of the widget itself.
export type WidgetInputs = Partial<Pick<WidgetDirective,
  'width' | 'height' | 'filters' | 'visible' | 'projects' | 'resize' | 'refreshSignal' | 'signalSingled' | 'visualSignal' | 'tenantId' | 'excludeProjects'>>;

export interface WidgetRegistration {
  component: Type<WidgetDirective>;
  // Inputs only this type receives, besides the shared ones.
  extraInputs?: readonly (keyof WidgetInputs)[];
  // Sends its aggregate query back to the editor.
  emitsQuery?: boolean;
}

export const SHARED_WIDGET_INPUTS: readonly (keyof WidgetInputs)[] =
  ['width', 'height', 'filters', 'refreshSignal', 'signalSingled', 'visualSignal', 'tenantId', 'excludeProjects'];

// Widget type (WidgetV2.type) → how to render it. A new type = one entry here + its component.
export const WIDGET_REGISTRY: Readonly<Record<string, WidgetRegistration>> = {
  chart: { component: ChartComponent, extraInputs: ['visible', 'projects', 'resize'], emitsQuery: true },
  block: { component: TextComponent, emitsQuery: true },
  forge: { component: ForgeComponent },
  planning3D: { component: PlanningWidget },
  image: { component: ImageComponent },
  map: { component: MapsComponent },
  table: { component: TableComponent },
  video: { component: VideoComponent },
  weather: { component: WeatherComponent },
  heatmap: { component: HeatmapComponent },
  projectMap: { component: ProjectMapComponent },
  insight: { component: InsightComponent, extraInputs: ['visible', 'projects', 'resize'], emitsQuery: true },
};
